import React, {createRef} from 'react'

type Props = {
    className?          : string
    style?              : any

    value               : any               // cur Value string | number
    disabled            : boolean
    placeholder?        : string

    type                : 'text' | 'password' | 'number'

    pattern?            : string
    step?               : string            //from number only

    commitDelay         : number
    autoSaveChanges     : boolean
    autoSaveOnBlur      : boolean
    focusOnMount        : boolean
    selectOnFocus?      : boolean
    autoSaveOnUnmount   : boolean

    onImmediateChange?  : func
    onFocus?            : func
    onBlur?             : func
    onChange?           : func              // on value change callback
    onEnter?            : func
    onEscape?           : func
}

type State = {
    value: any
}

export default class InputInlineEditable extends React.Component<Props, State> {

    private commited: boolean = true
    private debounceOnChange: any
    private refInput: any = createRef()

    static defaultProps = {
        disabled            : false,
        type                : 'text',

        commitDelay         : 600,
        autoSaveChanges     : true,
        autoSaveOnBlur      : false,
        autoSaveOnUnmount   : false,

        focusOnMount        : false
    }

    constructor(props: Props) {
        super(props)

        this.debounceOnChange = _.debounce(this.commitOnChange, this.props.commitDelay)

        this.state = {
            value: this.props.value
        }
    }

    UNSAFE_componentWillReceiveProps(newProps: Props) {
        if (this.commited && this.state.value !== newProps.value) {
            this.setState({
                value: newProps.value
            })
        }
    }

    componentDidMount() {
        if (this.props.focusOnMount) {
            this.focus()
        }
    }

    componentWillUnmount() {
        this.debounceOnChange.cancel()

        if (this.props.autoSaveOnUnmount) {
            this.commitOnChange(this.state.value, true);
        }
    }

    commit = () => {
        this.commitOnChange(this.state.value, true)
    }

    commitOnChange = (newValue: any, immediateSave: boolean = false) => {
        this.commited = true

        if (this.props.type === 'text' && newValue && typeof newValue === 'string') {
            newValue = newValue.trim()
        }

        this.props.onChange?.(newValue, immediateSave)
    }

    /*isEllipsisActive = () => {
        const node: any = ReactDOM.findDOMNode(this)
        return (node.offsetWidth < node.scrollWidth)
    }*/

    focus = () => {
        this.refInput.current.focus()
    }

    blur = () => {
        this.refInput.current.blur()
    }

    getValue = () => {
        return this.state.value
    }

    select = () => {
        this.refInput.current.select()
    }

    onFocus = (e: any) => {
        if (this.props.selectOnFocus) this.refInput.current.select()
        if (this.props.onFocus) this.props.onFocus(e)
    };

    onBlur = (e: any) => {
        if (this.props.onBlur) this.props.onBlur(e)

        if (this.props.autoSaveChanges || this.props.autoSaveOnBlur){
            this.debounceOnChange.cancel()
            this.commitOnChange(this.state.value)
        }
    }

    onInputKeyDown = (event: React.KeyboardEvent) => {
        switch (event.key) {
            case "Enter":
                if (this.props.onEnter) this.props.onEnter()
                else this.refInput.current.blur()

                if (!this.props.autoSaveChanges && !this.props.autoSaveOnBlur) {
                    this.commitOnChange(this.state.value)
                }
                break

            case "Escape":
                event.preventDefault()
                this.props.onEscape?.()
                break
        }
    }

    onChange = (event: any) => {
        this.commited = false
        let newValue = event.target.value

        if (this.props.autoSaveChanges) this.debounceOnChange(newValue)
        this.setState({
            value:newValue
        }, ()=>{
            this.props.onImmediateChange?.(newValue)
        })
    }

    render() {
        const classes = Classes("gd-input-inline-editable", this.props.className, {
            empty: this.state.value === null || this.state.value === undefined
        })

        const value = !_.isNil(this.state.value) ? this.state.value : ""

        return (
            <input ref          = {this.refInput}
                   className    = {classes}
                   style        = {this.props.style}
                   placeholder  = {this.props.placeholder}
                   value        = {value}
                   type         = {this.props.type}
                   pattern      = {this.props.pattern}
                   step         = {this.props.step}
                   disabled     = {this.props.disabled}
                   onKeyDown    = {this.onInputKeyDown}
                   onFocus      = {this.onFocus}
                   onBlur       = {this.onBlur}
                   onChange     = {this.onChange}/>
        )
    }
}